// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--xZ1h9","flash":"_9e1425b4d3--flash--CWPJB","title":"_9e1425b4d3--title--mRTgO","description":"_9e1425b4d3--description--vE7Gm"};